module.exports = __webpack_public_path__ + "img/column_maobi1.563a2dd3.png";